//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import ReelId from '@models/ReelId';
import { getIsShareV2Vendor } from '@redux/selectors/getSessionInfo';
import { EditorDisabledNotes } from '@uia/products/EditorDisabledNotes';
import { WorkflowTooltips } from '@uia/products/WorkflowTooltips';
import { useProductTaggingContext } from '@uia/products/context/ProductTaggingContext';
import { ProductTagsList } from '@uia/products/product-tags/ProductTagsList';
import { SkuLimit } from '@uia/products/sku-limit/SkuLimit';
import { getIsBazaarvoiceNetworkSyndicationFrontendEnabled } from '@uia/rights/selectors/getUIARights';
import { isDefined } from '@utils/filterPredicates';

export const TaggedProducts = () => {
  const {
    hasCatalogConnected,
    isProductEditingFeatureDisabled,
    metadata,
    removeAllProducts,
    removeProduct,
    reorderProducts,
    setIsTaggingProducts,
    setSelectedProductToEdit,
  } = useProductTaggingContext();

  const isShareV2VendorClient = useSelector(getIsShareV2Vendor);
  const isBazaarvoiceSyndicationEnabled = useSelector(
    getIsBazaarvoiceNetworkSyndicationFrontendEnabled,
  );
  return (
    <>
      {isShareV2VendorClient && !isBazaarvoiceSyndicationEnabled && (
        <SkuLimit />
      )}
      <WorkflowTooltips />

      <EditorDisabledNotes
        isProductTaggingDisabled={metadata.disableProductTagging}
        onSearchProductCatalog={() => setIsTaggingProducts(true)}
        reelId={
          isDefined(metadata.reelId) ? ReelId(metadata.reelId) : undefined
        }
      />

      <ProductTagsList
        isCatalogConnected={hasCatalogConnected}
        isProductEditingFeatureDisabled={isProductEditingFeatureDisabled}
        onEditProductTag={(productTag) => setSelectedProductToEdit(productTag)}
        onRemoveAllProductTags={removeAllProducts}
        onRemoveProductTag={(productTagToRemove) => {
          if (isDefined(productTagToRemove.productStyleId)) {
            const indexToRemove = productTagToRemove.position - 1;

            // Only remove the item if both its index and productStyleId match.
            const remainingProductTags = metadata.productTags.filter(
              (tag, index) =>
                index !== indexToRemove ||
                tag.productStyleId !== productTagToRemove.productStyleId,
            );

            removeProduct({
              productStyleId: productTagToRemove.productStyleId,
              listOfProducts: remainingProductTags,
            });
          }
        }}
        onReorderProductTags={(reorderedProducts) =>
          reorderProducts({ reorderedProducts })
        }
        productTags={metadata.productTags}
      />
    </>
  );
};
